import { TenantRepositoryLayout } from "../../../../TenantProfile"
import { Outlet } from "react-router"

export default function Layout() {
	return (
		<TenantRepositoryLayout>
			<Outlet />
		</TenantRepositoryLayout>
	)
}
